import {
  Box,
  Paper,
  Snackbar,
  Alert,
  Stack,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { Add, Delete, Edit } from "@mui/icons-material";
import EditModalASN from "./editModalASN";
import DeleteDialog from "../../../../componentes/deleteDialog";
import CreateModalASN from "./createModalASN";
import AlertModal from "../../../../componentes/alertModal";
import { ptBR } from "@mui/x-data-grid/locales";
const styles = {
  boxContainer: {
    minWidth: "320px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    left: 0,
    right: 0,
    mr: "auto",
    ml: "auto",
  },
  paperContainer: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    borderRadius: "0px 5px 5px 5px",
    width: "100%",
  },
  TextField: {
    width: "300px",
  },
  paperModal: {
    padding: "10px",
    borderRadius: 3,
  },
  dialogContent: { display: "flex", flexDirection: "column", gap: "20px" },
};
export default function ASNs(params) {
  const rows = [{ id: 14 }];
  //modal
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [errorName, setErrorName] = useState(false);
  //modal delete
  const [confirmarDelete, setConfirmarDelete] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  //tabela
  const [asns, setAsns] = useState([]);
  const [snackbar, setSnackbar] = useState(null);
  const [loadingTable, setLoadingTable] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 90,
      hide: true,
    },
    {
      field: "nome_asn",
      headerName: "Nome",
      width: 200,
    },
    {
      field: "asn",
      headerName: "ASN",
      flex: 3,
    },
    {
      field: "void",
      headerName: "",
      width: 100,
      flex: 1,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      //width: 40,

      renderCell: (params) => {
        const onClick = (e) => {
          //e.stopPropagation();
          // don't select this row after clicking
          const api = params.api;
          const thisRow = params.row;

          // api
          //   .getAllColumns()
          //   .filter((c) => c.field !== "__check__" && !!c)
          //   .forEach(
          //     (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
          //   );

          hanldeUpDateSelectRow(thisRow);
          setOpenEditModal(true);
        };
        function hanldeUpDateSelectRow(thisRow) {
          setSelectedRow(thisRow);
        }
        const onDelete = (e) => {
          e.stopPropagation(); // don't select this row after clicking

          const api = params.api;
          const thisRow = params.row;

          // api
          //   .getAllColumns()
          //   .filter((c) => c.field !== "__check__" && !!c)
          //   .forEach(
          //     (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
          //   );
          setOpenDeleteModal(true);
          setSelectedRow(thisRow);
        };
        //
        return (
          <Box key={params.id}>
            <Tooltip title={"Editar"} id="basic-button" onClick={onClick}>
              <IconButton size="small">
                <Edit color="primary" />
              </IconButton>
            </Tooltip>

            <IconButton onClick={onDelete}>
              <Delete color={"secondary"} />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  const comparaNome = (novoNome) => {
    return asns.some((asn) => asn.nome_asn === novoNome);
  };
  const comparaOutrosNomes = (novoNome, nomeAtual) => {
    const filtraAsns = asns.filter((asn) => asn.nome_asn !== nomeAtual);
    return filtraAsns.some((asn) => asn.nome_asn === novoNome);
  };

  function handleNewAsn(newAsn) {
    setAsns((asns) => [...asns, newAsn]);
  }
  function handleEditAsn(asnEditada) {
    setAsns((asns) =>
      asns.map((asn) => {
        if (asn.id === asnEditada.id) {
          return asnEditada;
        } else {
          return asn;
        }
      })
    );
  }
  function handleDeleteAsn(id) {
    setAsns((asns) => asns.filter((asn) => asn.id !== id));
  }
  useEffect(() => {
    handleApiGetAsns();
  }, []);

  async function handleApiGetAsns() {
    try {
      setLoadingTable(true);
      const response = await api.post("/relatoriosFlow/asn/findMany", {
        //acessoProdutoId,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar dados",
          severity: "error",
        });
      } else {
        if (response.data) {
          setAsns(response.data);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setLoadingTable(false);
    }
  }

  async function handleApiDeleteAsn() {
    try {
      setLoadingTable(true);
      setConfirmarDelete(true);
      const response = await api.put("/relatoriosFlow/asn/delete", {
        id: selectedRow.id,
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível excluir dados",
          severity: "error",
        });
      } else {
        setSnackbar({
          children: "Dados excluídos com sucesso",
          severity: "success",
        });
        if (response.data) {
          handleDeleteAsn(response.data.id);
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível se conectar com o servidor",
        severity: "error",
      });
    } finally {
      setLoadingTable(false);
      setConfirmarDelete(false);
      setOpenDeleteModal(false);
    }
  }
  return (
    <>
      <Box sx={styles.boxContainer}>
        <Paper sx={styles.paperContainer} elevation={3}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            {/*<Typography variant="h6">ASNs Flow</Typography>*/}
            <Box></Box>
            <Button
              variant="contained"
              disabled={loadingTable}
              startIcon={<Add />}
              onClick={() => {
                setOpenCreateModal(true);
              }}
            >
              Adicionar
            </Button>
          </Stack>
          <DataGrid
            sx={{
              fontSize: 15,
              "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                outline: "none !important",
              },
              ".MuiDataGrid-cell": { display: "flex", alignItems: "center" },
            }}
            //getRowHeight={() => "auto"}
            autoHeight={true}
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
            rows={asns}
            columns={columns}
            initialState={{
              ...rows.initialState,
              columns: {
                columnVisibilityModel: {
                  // Hide columns status and traderName, the other columns will remain visible
                  id: false,
                },
              },
            }}
            loading={loadingTable}
            disableColumnMenu
            // checkboxSelection
            disableRowSelectionOnClick={true}
          />{" "}
        </Paper>
      </Box>{" "}
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
      <CreateModalASN
        setOpenCreateModal={setOpenCreateModal}
        openCreateModal={openCreateModal}
        setSnackbar={setSnackbar}
        setLoadingTable={setLoadingTable}
        styles={styles}
        selectedRow={selectedRow}
        setErrorName={setErrorName}
        errorName={errorName}
        comparaNome={comparaNome}
        handleNewAsn={handleNewAsn}
        //acessoClientesId={acessoClientesId}
      />
      <EditModalASN
        setOpenEditModal={setOpenEditModal}
        openEditModal={openEditModal}
        setSnackbar={setSnackbar}
        setLoadingTable={setLoadingTable}
        styles={styles}
        selectedRow={selectedRow}
        setErrorName={setErrorName}
        errorName={errorName}
        comparaOutrosNomes={comparaOutrosNomes}
        handleEditAsn={handleEditAsn}
      />
      <AlertModal
        openModal={openDeleteModal}
        setOpenModal={setOpenDeleteModal}
        confirmar={confirmarDelete}
        handleButton={handleApiDeleteAsn}
        severity={"error"}
        singleButton={false}
      />
    </>
  );
}
